import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowRight, 
  Check, 
  MessageSquare, 
  BarChart2, 
  Zap, 
  RotateCw, 
  Award, 
  Shield, 
  Box 
} from 'lucide-react';

import { Container, Row, Col, Button } from "react-bootstrap";
import "./VideoSection.css"; // Your CSS file

import video2 from '../Components/Images/esl/esl.mp4'

import './hanshow.css'

// Bootstrap CSS would be imported in your main app file:
import 'bootstrap/dist/css/bootstrap.min.css';

import img1 from '../Components/Images/esl/esl_hero2.png'
import img10 from '../Components/Images/esl/nebula/n_200.png'
import img11 from '../Components/Images/esl/nebula/n_213.png'
import img12 from '../Components/Images/esl/nebula/n_266.png'
import img13 from '../Components/Images/esl/nebula/n_290.png'
import img14 from '../Components/Images/esl/nebula/n_346.png'
import img15 from '../Components/Images/esl/nebula/n_350.png'
import img16 from '../Components/Images/esl/nebula/n_420.png'
import img17 from '../Components/Images/esl/nebula/n_54.png'
import img18 from '../Components/Images/esl/nebula/n_583.png'
import img19 from '../Components/Images/esl/nebula/n_750.png'
import ESLProductCatalog from './ESLProductCatalog';
import ProductShowcase from './ProductShowcase';
import ProductShowCase1 from './ProductShowCase1';
import ImageGallery from './ImageGallery';

export default function Hanshowclaude() {
  const [activeTab, setActiveTab] = useState('all');

  const section2Ref = useRef(null);

  const navigate=useNavigate();
  const handleclick=()=>{
    navigate('/contact-us');
    window.scrollTo(0, 0);

  }

  const scrollToSection1 = () => {
    section2Ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  
  // Product models data
  const products = [
    {
      id: 1,
      name: "Stellar E31",
      description: "Perfect for grocery and small retail items. 2.13\" e-ink display.",
      category: "small",
      features: ["2.13\" display", "5-year battery life", "NFC enabled"],
      image:img10
    },
    {
      id: 2,
      name: "Nebula E42",
      description: "Ideal for electronics and detailed product information. 4.2\" high-resolution display.",
      category: "medium",
      features: ["4.2\" display", "Advanced color options", "QR code support"],
      image:img11
    },
    {
      id: 3,
      name: "Galaxy E75",
      description: "Premium large format for clothing, luxury items, and promotional displays.",
      category: "large",
      features: ["7.5\" display", "Full graphical support", "Extended connectivity"],
      image:img12
    },
    {
      id: 4,
      name: "Aurora E27",
      description: "Versatile mid-size label with color options for various retail segments.",
      category: "medium",
      features: ["2.7\" display", "3-color e-ink", "Quick response time"],
      image:img13
    },
    {
      id: 5,
      name: "Comet E13",
      description: "Ultra-compact size for small items and tight shelf spaces.",
      category: "small",
      features: ["1.3\" display", "Miniature design", "Ultra-energy efficient"],
      image:img14
    },
    {
      id: 6,
      name: "Supernova E58",
      description: "Our largest display for impactful promotions and department signage.",
      category: "large",
      features: ["5.8\" display", "Rich content support", "Advanced promotional features"],
      image:img15
    },
    {
      id: 7,
      name: "Supernova E58",
      description: "Our largest display for impactful promotions and department signage.",
      category: "large",
      features: ["5.8\" display", "Rich content support", "Advanced promotional features"],
      image:img16
    },
    {
      id: 8,
      name: "Supernova E58",
      description: "Our largest display for impactful promotions and department signage.",
      category: "large",
      features: ["5.8\" display", "Rich content support", "Advanced promotional features"],
      image:img17
    },
    {
      id: 9,
      name: "Supernova E58",
      description: "Our largest display for impactful promotions and department signage.",
      category: "large",
      features: ["5.8\" display", "Rich content support", "Advanced promotional features"],
      image:img18
    },
    {
      id: 10,
      name: "Supernova E58",
      description: "Our largest display for impactful promotions and department signage.",
      category: "large",
      features: ["5.8\" display", "Rich content support", "Advanced promotional features"],
      image:img19
    }
  ];
  
  // Filter products based on active tab
  const filteredProducts = activeTab === 'all' 
    ? products 
    : products.filter(product => product.category === activeTab);

  return (
    <div className="font-sans">
      {/* Hero Section */}
      <header className="position-relative  bg-new  text-white py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h1 className="display-6 fw-bold mb-3">Revolutionize Your Retail with Hanshow Electronic Shelf Labels</h1>
              <p className="lead mb-4">Dynamic pricing, real-time updates, and operational efficiency — all in one smart label.</p>
              <div className="d-flex flex-column flex-sm-row gap-3">
                <button className="btn btn-light text-primary fw-semibold px-4 py-2" onClick={scrollToSection1}>
                  Request a Demo
                </button>
                <button className="btn btn-outline-light fw-semibold px-4 py-2" >
                  Get a Quote
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className=" overflow-hidden">
                {/* Placeholder for retail environment image */}
                <div className=" d-flex align-items-center justify-content-center" style={{ height: '350px' }}>
                  <img src={img1} alt="Electronic Shelf Labels in retail environment" className="w-100 h-100 object-fit-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* No direct equivalent for the wave divider in Bootstrap - would need custom SVG */}
        <div className="position-absolute bottom-0 start-0 end-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-100">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,42.7C1120,32,1280,32,1360,32L1440,32L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
          </svg>
        </div>
      </header>

      {/* What is Hanshow ESL? */}
      <section className="py-5 bg-white">
        <div className="container py-3">
          <h2 className="text-center fw-bold mb-5">What is Hanshow ESL?</h2>
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8">
              <p className="text-center fs-5 mb-5">Electronic Shelf Labels (ESLs) are digital display devices that replace traditional paper price tags, allowing retailers to instantly update pricing and product information across their entire store network from a central management system.</p>
              
              <div className="row mt-5">
                <div className="col-md-4 text-center p-3">
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                      <Zap className="" style={{color:"#3ec63e"}} size={24} />
                    </div>
                  </div>
                  <h3 className="fw-semibold fs-5 mb-2">Energy Efficient</h3>
                  <p>Battery life of 5+ years with e-ink technology that only uses power when changing content.</p>
                </div>
                
                <div className="col-md-4 text-center p-3">
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                      <RotateCw className="" style={{color:"#3ec63e"}} size={24} />
                    </div>
                  </div>
                  <h3 className="fw-semibold fs-5 mb-2">Real-Time Updates</h3>
                  <p>Instantly update thousands of prices across your stores with just a few clicks.</p>
                </div>
                
                <div className="col-md-4 text-center p-3">
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                      <MessageSquare className="" style={{color:"#3ec63e"}} size={24} />
                    </div>
                  </div>
                  <h3 className="fw-semibold fs-5 mb-2">Enhanced Communication</h3>
                  <p>Display more than just prices - show promotions, stock levels, and product details.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-5 bg-light">
        <div className="container py-3">
          <h2 className="text-center fw-bold mb-5">Key Features</h2>
          
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <BarChart2 className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">Responsive Pricing</h3>
                  </div>
                  <p className="card-text">Adjust prices based on demand, competition, time of day, or inventory levels in real-time.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <Box className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">Integration with POS/ERP</h3>
                  </div>
                  <p className="card-text">Seamlessly connects with your existing point-of-sale and enterprise resource planning systems.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <Award className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">Multiple Sizes and Colors</h3>
                  </div>
                  <p className="card-text">Choose from various display sizes and color options to meet your specific retail needs.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <MessageSquare className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">NFC/QR Enabled</h3>
                  </div>
                  <p className="card-text">Enhance customer engagement with interactive features allowing shoppers to access detailed product information.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <Zap className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">Ultra-low Power Consumption</h3>
                  </div>
                  <p className="card-text">Environment-friendly operation with batteries lasting 5+ years under normal usage conditions.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                      <Shield className="" style={{color:"#3ec63e"}} size={20} />
                    </div>
                    <h3 className="fs-5 fw-semibold mb-0">Cloud-based Management</h3>
                  </div>
                  <p className="card-text">Secure, centralized control system accessible from anywhere with robust permissions and role management.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* video section */}

      <section className="w3l-video" id="video">
      <div className="video-overlay"></div>
      <div className="video-mid-w3 py-5">
        <Container>
          <Row className="align-items-center">
            {/* Left Column - Text Content */}
            <Col lg={6} className="mb-5 mb-lg-0 pe-lg-3 text-white">
              <div className="title-content text-left">
                <h6 className="title-subhny mb-2">Time to Grow Smarter</h6>
                <h3 className="title-w3l two">Make pricing and promotions effortless</h3>
              </div>
              <p className="mt-md-4 mt-3">
             From dynamic pricing to real-time inventory updates, Sensetech Trading LLC delivers cutting-edge Electronic Shelf Label (ESL) technology that transforms retail efficiency.
              </p>
              <h6>Reliable integration, lightning-fast updates, and trusted service across Dubai.</h6>
              <div className="w3l-two-buttons mt-4">
                <button  className="me-2"  style={{fontFamily:"Poppins", backgroundColor:"#3ec63e"}} onClick={scrollToSection1}>Explore Products</button>
                <button variant="outline-light" onClick={handleclick}>Get a Free Quote</button>
              </div>
            </Col>

            {/* Right Column - Video */}
            <Col lg={6} className="ps-lg-5">
              {/* <div className="video-container position-relative">
                <div className="play-button-wrapper">
                  <a href={video2} className="popup-with-zoom-anim play-view">
                    <span className="video-play-icon">
                      <span className="fa fa-play"></span>
                    </span>
                  </a>
                </div>
              </div> */}
              <div className="">
                <video width="100%" controls>
                  <source src={video2} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>

      {/* Benefits for Retailers */}
      <section className="py-5 bg-white">
        <div className="container py-3">
          <h2 className="text-center fw-bold mb-5">Benefits for Retailers</h2>
          
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className="text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Reduce Labor Cost</h3>
                  <p className="card-text">Eliminate manual price changes and redirect staff to more valuable customer service activities.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className="text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Eliminate Pricing Errors</h3>
                  <p className="card-text">Ensure 100% price accuracy between shelf and checkout, increasing customer satisfaction and trust.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className=" text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Improve Customer Experience</h3>
                  <p className="card-text">Provide clear pricing, detailed product information, and eliminate checkout surprises.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className=" text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Enhance Shelf-edge Communication</h3>
                  <p className="card-text">Display more than just prices - show promotions, product origins, allergen info, and more.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className="text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Support Dynamic Pricing</h3>
                  <p className="card-text">Implement time-based promotions, flash sales, and inventory-based pricing automatically.</p>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 bg-light border-0">
                <div className="card-body p-4">
                  <div className=" text-white d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                    <Check size={24} />
                  </div>
                  <h3 className="fs-5 fw-semibold mb-3">Reduce Environmental Impact</h3>
                  <p className="card-text">Cut paper waste from traditional price tags while using energy-efficient e-ink technology.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Range */}
      {/* <section>
        <ESLProductCatalog/>
      </section> */}

      <section ref={section2Ref}>
        <ProductShowcase/>
      </section>
      {/* <section>
        <ProductShowCase1/>
      </section> */}
      
      <section>
        <ImageGallery/>
      </section>
      

      {/* How It Works */}
      <section className="py-5 bg-white">
        <div className="container py-3">
          <h2 className="text-center fw-bold mb-5">How It Works</h2>
          
          <div className="row justify-content-center text-center">
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="d-inline-flex justify-content-center align-items-center text-white rounded-circle mb-3" style={{ width: '60px', height: '60px', backgroundColor:"#3ec63e" }}>
                <span className="fw-bold fs-4">1</span>
              </div>
              <h3 className="fs-5 fw-semibold mb-3">Integrate with your POS system</h3>
              <p className="text-muted">Our team helps set up seamless integration with your existing point-of-sale and inventory management systems.</p>
            </div>
            
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="d-inline-flex justify-content-center align-items-center text-white rounded-circle mb-3" style={{ width: '60px', height: '60px', backgroundColor:"#3ec63e" }}>
                <span className="fw-bold fs-4">2</span>
              </div>
              <h3 className="fs-5 fw-semibold mb-3">Update prices through the cloud</h3>
              <p className="text-muted">Use the intuitive cloud-based management system to control pricing, promotions, and product information.</p>
            </div>
            
            <div className="col-md-4">
              <div className="d-inline-flex justify-content-center align-items-center text-white rounded-circle mb-3" style={{ width: '60px', height: '60px', backgroundColor:"#3ec63e" }}>
                <span className="fw-bold fs-4">3</span>
              </div>
              <h3 className="fs-5 fw-semibold mb-3">ESLs display updated info instantly</h3>
              <p className="text-muted">Changes appear immediately on all electronic shelf labels throughout your store network.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-5 bg-dark text-white">
        <div className="container py-3">
          <h2 className="text-center fw-bold mb-5">Why Choose Sensetech Trading LLC?</h2>
          
          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="p-3">
                <div className="rounded-circle d-flex justify-content-center align-items-center mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                  <Shield className="text-white" size={24} />
                </div>
                <h3 className="fs-5 fw-semibold mb-3">Authorized Distributor</h3>
                <p>Official Hanshow partner with direct manufacturer support and warranty coverage.</p>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-3">
              <div className="p-3">
                <div className="rounded-circle d-flex justify-content-center align-items-center mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                  <MessageSquare className="text-white" size={24} />
                </div>
                <h3 className="fs-5 fw-semibold mb-3">Expert Consultation</h3>
                <p>Tailored solutions designed specifically for your retail environment and business needs.</p>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-3">
              <div className="p-3">
                <div className="rounded-circle d-flex justify-content-center align-items-center mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                  <RotateCw className="text-white" size={24} />
                </div>
                <h3 className="fs-5 fw-semibold mb-3">Seamless Implementation</h3>
                <p>End-to-end support from system integration to staff training and ongoing assistance.</p>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-3">
              <div className="p-3">
                <div className="rounded-circle d-flex justify-content-center align-items-center mb-3" style={{ width: '48px', height: '48px', backgroundColor:"#3ec63e" }}>
                  <Award className="text-white" size={24} />
                </div>
                <h3 className="fs-5 fw-semibold mb-3">Local Support</h3>
                <p>Rapid response times with local technical support and service teams.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 bg-back text-white">
        <div className="container py-3 text-center">
          <h2 className="fw-bold mb-3">Ready to Transform Your Retail Experience?</h2>
          <p className="lead mx-auto mb-4" style={{ maxWidth: '700px' }}>Join thousands of retailers who have already embraced the future of pricing and inventory management with Hanshow ESL solutions.</p>
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <button className="btn btn-light fw-semibold px-4 py-2" 
            style={{color:"#3ec63e"}}
            onClick={handleclick}>
              Request a Demo
            </button>
            <button className="btn btn-outline-light fw-semibold px-4 py-2" onClick={handleclick}>
              Contact Sales
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      
    </div>
  );
}